"use client";

import { c as _c } from "react/compiler-runtime";
import { AccountLockup, AccountLockupAvatar } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { Item, Link } from "@opensea/next-ui-kit";
import { LiveAnimation, NumberDisplay, TableCell, TableRow, TextBody, tableRowSizeVariants } from "@opensea/ui-kit";
import { getProfileUrl } from "@/components/account/utils";
import { ActivityFeedLiveTimestamp } from "@/components/activity-feed/ActivityFeedLiveTimestamp";
import { ActivityPrice } from "@/components/activity-feed/ActivityPrice";
import { MINT_FEED_TABLE_COLUMN_CLASSNAMES } from "@/components/collection/drops/constants";
import { useAddress } from "@/hooks/wallet";
import { MintFeedTableRowFragment } from "./MintFeedTableRow.fragment";
import { MintFeedTableRowSkeleton } from "./MintFeedTableRowSkeleton";
export function MintFeedTableRow(t0) {
  const $ = _c(15);
  const {
    context,
    item: itemKey
  } = t0;
  const activity = readFragment(MintFeedTableRowFragment, itemKey);
  const {
    text
  } = tableRowSizeVariants({
    size: "md"
  });
  const connectedAddress = useAddress();
  if (activity?.__typename !== "Mint" || !(activity.item || activity.collection)) {
    const t1 = context?.override;
    let t2;
    if ($[0] !== t1) {
      t2 = <MintFeedTableRowSkeleton override={t1} />;
      $[0] = t1;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  const t1 = getProfileUrl(activity.minter);
  const t2 = activity.id;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AccountLockupAvatar className="flex-shrink-0" size={24} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const T0 = TableCell;
  const t4 = MINT_FEED_TABLE_COLUMN_CLASSNAMES;
  const T1 = TextBody;
  const t5 = text();
  let t6;
  if ($[3] !== activity.quantity) {
    t6 = <NumberDisplay display="quantity" value={activity.quantity} />;
    $[3] = activity.quantity;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== T1 || $[6] !== t5 || $[7] !== t6) {
    t7 = <T1 className={t5}>{t6}</T1>;
    $[5] = T1;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== T0 || $[10] !== t4.quantity || $[11] !== t7) {
    t8 = <T0 className={t4.quantity}>{t7}</T0>;
    $[9] = T0;
    $[10] = t4.quantity;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== activity) {
    t9 = <TableCell className={MINT_FEED_TABLE_COLUMN_CLASSNAMES.timestamp}><ActivityFeedLiveTimestamp activity={activity} showArrow={true} /></TableCell>;
    $[13] = activity;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return <Link href={t1} variant="unstyled"><LiveAnimation itemKey={t2} liveAddedAt={context?.itemsLiveAddedAt?.get(activity.id)} variant="table"><TableRow className="w-full" interactive={true}><TableCell className={MINT_FEED_TABLE_COLUMN_CLASSNAMES.item}><Item variant="unstyled"><AccountLockup account={activity.minter} addressDisplay="compact" avatar={t3} className={text()} connectedAddress={connectedAddress ?? null} /></Item></TableCell><TableCell className={MINT_FEED_TABLE_COLUMN_CLASSNAMES.price}><ActivityPrice activity={activity} className={text()} /></TableCell>{t8}{t9}</TableRow></LiveAnimation></Link>;
}